__turbopack_context__.v({
  "loginPage": "Login-module__Ty4I2W__loginPage",
});
